import * as zod from "zod";

const SourceCountSchema = zod.object({
  promptResponseId: zod.bigint(),
  sourceCount: zod.number(),
});

export const getAeoPromptResponseSourceCounts = {
  name: "getAeoPromptResponseSourceCounts" as const,
  input: zod.object({ promptResponseIds: zod.array(zod.bigint()) }),
  output: zod.object({ sourceCounts: zod.array(SourceCountSchema) }),
};
